import React from 'react'
import PropTypes from 'prop-types'
import { generateNewTabName } from '../../../helper/generateNewTabName'

const Button = ({ onClick, style, button, title, openIframe }) => {
  if (button.type === 'postback') {
    return (
      <button style={style} onClick={onClick} className="template_button">
        {title}
      </button>
    )
  }

  if (button.type === 'web_url' && !button.isWebview) {
    return (
      <a
        style={style}
        href={button.url}
        className="template_button"
        target={generateNewTabName()}>
        {title}
      </a>
    )
  }

  if (button.type === 'web_url' && button.isWebview) {
    return (
      <span
        style={style}
        className="template_button"
        onClick={openIframe.bind(null, button.url)}>
        {title}
      </span>
    )
  }

  if (button.type === 'reset') {
    return (
      <span
        style={style}
        className="template_button"
        onClick={() => window.location.reload()}>
        {title}
      </span>
    )
  }
}

Button.propTypes = {
  style: PropTypes.object,
  openIframe: PropTypes.func,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  button: PropTypes.object.isRequired,
}

export default Button
